import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from './SafeIcon';
import {products} from '../data/products';
import ProductCard from './ProductCard';

const {FiArrowUpRight} = FiIcons;
const filters = ['All','Clothing','Accessories','Jewelry'];
const waLink = (t) => `https://wa.me/919876543210?text=${encodeURIComponent(t)}`;

function ProductSection({onAdd}) {
  const [active,setActive] = useState('All');
  const visible = active === 'All' ? products : products.filter(p => p.category === active);

  return (
    <section id="shop" className="bg-[#F7F2EA] py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div>
            <p className="eyebrow mb-4" style={{color: '#1F3D2E'}}>The love list</p>
            <h2 className="font-display text-[clamp(36px,5vw,64px)] leading-tight text-[#1F1B17] font-light">
              Pieces you will <em className="italic text-[#1F3D2E]">keep</em>
            </h2>
          </div>
          <a href={waLink('Hi Aurelle! Please share your full collection.')} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-3 border-b border-[#1F1B17]/30 pb-2 font-sans text-[11px] tracking-[0.2em] uppercase text-[#1F1B17] hover:text-[#1F3D2E] hover:border-[#1F3D2E] transition">
            View everything <SafeIcon icon={FiArrowUpRight} className="group-hover:translate-x-1 transition" />
          </a>
        </div>
        <div className="flex items-center gap-8 mb-10 border-b border-[#DDD3BE] pb-4 overflow-x-auto">
          {filters.map(f => (
            <button key={f} onClick={() => setActive(f)} className={`font-sans text-[11px] tracking-[0.2em] uppercase whitespace-nowrap pb-2 transition relative ${active === f ? 'text-[#1F3D2E]' : 'text-[#7A6E62]'}`}>
              {f}
              {active === f && <span className="absolute -bottom-4 left-0 right-0 h-0.5 bg-[#1F3D2E]" />}
            </button>
          ))}
          <span className="ml-auto font-sans text-[10px] text-[#7A6E62] whitespace-nowrap">{visible.length} pieces</span>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {visible.map(p => <ProductCard key={p.id} product={p} onAdd={onAdd} />)}
        </div>
      </div>
    </section>
  );
}

export default ProductSection;
